import { TypedSopNode } from "./_Base";
import { AttribClassMenuEntries, ATTRIBUTE_CLASSES } from "../../../core/geometry/Constant";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { AudioNotesSopOperation, OUT_OF_RANGE_BEHAVIOR } from "../../operations/sop/AudioNotes";
const DEFAULT = AudioNotesSopOperation.DEFAULT_PARAMS;
class AudioNotesSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.class = ParamConfig.INTEGER(DEFAULT.class, {
      menu: {
        entries: AttribClassMenuEntries
      }
    });
    this.name = ParamConfig.STRING(DEFAULT.name);
    this.toctave = ParamConfig.BOOLEAN(0);
    this.octaveName = ParamConfig.STRING(DEFAULT.octaveName, {
      visibleIf: { toctave: 1 }
    });
    this.startOctave = ParamConfig.INTEGER(DEFAULT.startOctave, { range: [1, 8], rangeLocked: [true, true] });
    this.endOctave = ParamConfig.INTEGER(DEFAULT.endOctave, { range: [1, 8], rangeLocked: [true, true] });
    this.outOfRangeBehavior = ParamConfig.INTEGER(DEFAULT.outOfRangeBehavior, {
      menu: {
        entries: OUT_OF_RANGE_BEHAVIOR.map((name, i) => {
          return { value: i, name };
        })
      }
    });
  }
}
const ParamsConfig = new AudioNotesSopParamsConfig();
export class AudioNotesSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "audioNotes";
  }
  initializeNode() {
    this.io.inputs.setCount(1);
    this.io.inputs.initInputsClonedState(AudioNotesSopOperation.INPUT_CLONED_STATE);
  }
  cook(input_contents) {
    this._operation = this._operation || new AudioNotesSopOperation(this.scene(), this.states);
    const core_group = this._operation.cook(input_contents, this.pv);
    this.setCoreGroup(core_group);
  }
  setClass(attribClass) {
    this.p.class.set(ATTRIBUTE_CLASSES.indexOf(attribClass));
  }
}
